import React from 'react';

const PHIAuditSummary = ({ summary }) => {
  const collectionsScanned =
    typeof summary.collectionsScanned === 'number' ? summary.collectionsScanned : 0;

  const fieldsScanned = typeof summary.fieldsScanned === 'number' ? summary.fieldsScanned : 0;

  const phiFieldsDetected =
    typeof summary.phiFieldsDetected === 'number' ? summary.phiFieldsDetected : 0;

  const filtersScanned = typeof summary.filtersScanned === 'number' ? summary.filtersScanned : 0;

  const filtersWithPhiExposure =
    typeof summary.filtersWithPhiExposure === 'number' ? summary.filtersWithPhiExposure : 0;

  const pagesScanned = typeof summary.pagesScanned === 'number' ? summary.pagesScanned : 0;

  const publicPagesWithPhiExposure =
    typeof summary.publicPagesWithPhiExposure === 'number' ? summary.publicPagesWithPhiExposure : 0;

  return (
    <div className="row g-3 mb-4">
      <div className="col-md-3">
        <div className="border rounded p-3 h-100">
          <div className="text-muted small mb-1">Collections Scanned</div>

          <div className="fs-4 fw-bold">{collectionsScanned}</div>

          <div className="text-muted small mt-1">Project collections</div>
        </div>
      </div>

      <div className="col-md-3">
        <div className="border rounded p-3 h-100">
          <div className="text-muted small mb-1">PHI Fields Detected</div>

          <div className={`fs-4 fw-bold ${phiFieldsDetected > 0 ? 'text-danger' : 'text-success'}`}>
            {phiFieldsDetected}
          </div>

          <div className="text-muted small mt-1">{fieldsScanned} fields scanned</div>
        </div>
      </div>

      <div className="col-md-3">
        <div className="border rounded p-3 h-100">
          <div className="text-muted small mb-1">Public Filters With PHI</div>

          <div
            className={`fs-4 fw-bold ${
              filtersWithPhiExposure > 0 ? 'text-danger' : 'text-success'
            }`}
          >
            {filtersWithPhiExposure}
          </div>

          <div className="text-muted small mt-1">{filtersScanned} filters scanned</div>
        </div>
      </div>

      <div className="col-md-3">
        <div className="border rounded p-3 h-100">
          <div className="text-muted small mb-1">Public Pages With PHI</div>

          <div
            className={`fs-4 fw-bold ${
              publicPagesWithPhiExposure > 0 ? 'text-danger' : 'text-success'
            }`}
          >
            {publicPagesWithPhiExposure}
          </div>

          <div className="text-muted small mt-1">{pagesScanned} pages scanned</div>
        </div>
      </div>
    </div>
  );
};

export default PHIAuditSummary;
